<template>
    <v-layout column>
        <v-flex xs12>
            <v-form ref="form" v-model="valid">
                <v-text-field label="Note" :rules="[v => (v && v.length > 3) || 'Name must be more than 3 characters']"
                              v-model="note.note" required prepend-icon="note"/>
                <v-menu
                        v-if="!noExpiryDate"
                        ref="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                >
                    <template slot="activator">
                        <v-text-field
                                v-model="note.expiry_date"
                                label="Date"
                                persistent-hint
                                prepend-icon="event"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="note.expiry_date" no-title></v-date-picker>
                </v-menu>
                <v-checkbox label="Show on dispatch" v-model="showOnDispatch"/>
                <v-checkbox label="No expiry date" v-model="noExpiryDate"></v-checkbox>
                <v-btn
                        color="success"
                        @click="validate"
                >
                    Submit Note
                </v-btn>
            </v-form>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "note-editor-component",
        props: ['value'],
        data() {
            return {
                note: this.value || {},
                noExpiryDate: true,
                valid: null,
                showOnDispatch: false
            }
        },
        watch: {
            showOnDispatch(val) {
                if (val)
                    this.note = Object.assign({},
                        this.note,
                        {
                            status: 'NEEDS_SOLVING'
                        });
                else
                    this.note = Object.assign({},
                        this.note,
                        {
                            status: 'NORMAL'
                        })
            },
            noExpiryDate(value) {
                if (value) this.note.date = null;
            },
            note: {
                handler(val) {
                    this.$emit("input", val);
                },
                deep: true
            }
        },
        methods: {
            validate() {
                if (this.$refs.form.validate()) {
                    this.$emit('submit');
                }
            },
        }
    }
</script>

<style scoped>

</style>